export default "__VITE_ASSET__abba000b__"